module.exports = __webpack_public_path__ + "static/img/logo@2x.bda7fc46.png";